import { Component, forwardRef, Input, OnInit, ViewChild } from '@angular/core';
import { LMDimension, LMNewTopNodeValuesResult, LMReportingBasis } from '@modal/cubes/lm-cubes';
import { LMLookupBasicComponent } from '@field/lookup';
import { LMCubeUtilService } from '@modal/cubes/lm-cube-util.service';
import { LMErrorUtilService } from '@app/services';
import { AppConstants } from '@app/utils';

@Component({
  selector:    'lm-cube-sructure',
  templateUrl: './lm-cube-structures.component.html',
})

export class LMCubeStructuresComponent implements OnInit {
  @Input() cubeBusClass: string;
  @Input() dimensionMapping: Array<LMDimension>;
  @Input() message: string;

  @Input() reportingBasis: LMReportingBasis
  @ViewChild(forwardRef(() => LMLookupBasicComponent)) lmLookupBasicReportingBasis;

  public hasReportingBasis: boolean;
  private cubePeriodKey: string;

  constructor(private lmCubeUtilService: LMCubeUtilService,
    private  lmErrorUtilService: LMErrorUtilService,
  ) {}
  ngOnInit(): void {
    this.hasReportingBasis = this.reportingBasis !== undefined;
  }

  public getDimensionMapping(): Array<LMDimension> {
    // Return Updated dimensions and values to the cube cell relation service.
    return this.dimensionMapping;
  }

  public getReportingBasis(): string {
    return (this.hasReportingBasis && this.lmLookupBasicReportingBasis) ? this.lmLookupBasicReportingBasis.lookupValue : undefined;
  }

  public getCubePeriodKey(): string {
    return this.cubePeriodKey;
  }

  public onContextValueChanged(event: LMFieldEvent) {
    // ngmodelchanged from lmLookupBasicReportingBasis
    // this.reportingBasis.resourceId = this.reportingBasis.resourceId.replace(this.reportingBasis.value, this.lmLookupBasicReportingBasis.lookupValue);
    this.reportingBasis.value = this.lmLookupBasicReportingBasis.lookupValue;
    this.lmCubeUtilService.getNewTopNodeValues(this.cubeBusClass, this.reportingBasis.cubeListName, this.lmLookupBasicReportingBasis.lookupValue)
      .subscribe((response: LMNewTopNodeValuesResult) => {
        if (response.message) {
          this.lmErrorUtilService.handleError(response.message);
          return;
        } else if ((response as any).status === AppConstants.STATUS_SYSTEM_ERROR) {
          const lmError = (response as any);
          this.lmErrorUtilService.handleError(lmError.message, lmError.details, lmError.status);
          return;
        }
        this.cubePeriodKey = response.periodKey;
        const dimensionMappingClone = JSON.parse(JSON.stringify(this.dimensionMapping));
        Object.keys(response.topNodes).forEach(key => {
          const dimension = dimensionMappingClone.find((dim) => dim.name === key);
          if (dimension) {
            dimension.value = response.topNodes[key].replace(/(\r\n|\n|\r)/gm, '/');
          }
        });
        this.dimensionMapping = dimensionMappingClone;
      });
  }
}
